export const FORM_INPUT_VALIDATION_ERROR_EVENT_NAME = 'validation-error';
export const FORM_INPUT_CLEAR_VALIDATION_ERRORS_EVENT_NAME = 'clear-validation-errors';
